import { useTranslation } from '@jupiter/plugin-runtime/i18n';
import { useHistory, useLocation } from 'react-router-dom';
import { CODE_SUCCESS } from '@features/constants/network';
import { LearningInfo } from '@/api/seller/serv/oec_seller_learning_center_api';
import { basename, RoleType } from '@/constants';
import { genLocationByLearningInfo } from '../../location';
import { useCourseModel } from '../models';
import { getQuery } from '@i18n-ecom/lib/dist/commonjs/url';
import { Tea } from '@features/libs/tea';
import { getPopReportQuery } from '@/hooks/usePopQuery';

export interface UseContentOptions {
  type: RoleType;
}

export const useContent = ({ type }: UseContentOptions) => {
  const { i18n } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const { menu, list, loadPage } = useCourseModel();
  const contentId = +(
    getQuery(location.search, 'content_id')?.toString() || ''
  );
  const item = menu[type]?.length ? list[contentId] : undefined;
  const fetch = (id: number, pageNumber: number) => {
    const repo = list[id] || {};
    const bucket = repo.bucket || {};
    const pageStr = `${i18n.language}_${pageNumber}`;

    if (repo.total === undefined || bucket[pageStr] === undefined) {
      return loadPage(id, pageNumber).then(res => ({
        error: res?.code !== CODE_SUCCESS,
        total: res?.data?.total || repo.total,
        items: res?.data?.learning_info || [],
      }));
    } else {
      loadPage(id, pageNumber);
    }

    return {
      total: repo.total || 0,
      items: bucket[pageStr] || [],
    };
  };
  const handleClick = (
    info: LearningInfo,
    tabName: string,
    index: number,
    pageNumber?: number,
  ) => {
    const nextLocation = genLocationByLearningInfo(
      history.location.search,
      info,
    );

    window.open(
      `/${basename}${nextLocation.pathname}?${nextLocation.search}&from=course`,
      '_blank',
    );

    Tea('button_click', {
      page_name: 'seller_university_homepage',
      module_name: 'seller_university_homepage_course',
      tab_name: tabName,
      click_for: 'seller_university_content_list_item',
      content_id: info.learning_id,
      content_name: info.name,
      index: index,
      page_num: pageNumber,
      ...getPopReportQuery(),
    });
  };

  return {
    handleClick,
    item,
    fetch,
  };
};
